import React from "react";
import generatorForm from "../../generator-form";
import { FormItemBox } from "../../../../components/form-item/form-item-box/form-item-box";
import { getPrograms } from "../../generator-utils";
import { getTooltipText } from "../../generator-tooltips";
export var ProgramForm = function (_a) {
    var tooltips = _a.tooltips;
    var program = generatorForm.program;
    var programs = getPrograms();
    return (React.createElement(React.Fragment, null,
        React.createElement(FormItemBox, { name: program.name, options: programs.map(function (_a) {
                var value = _a.value, name = _a.name, note = _a.note;
                return ({
                    value: value,
                    name: name,
                    note: note,
                    tooltip: getTooltipText(tooltips, value),
                });
            }) })));
};
